import LegalLayout from "@/pages/legal/LegalLayout";
import { SITE } from "@/data/site";

export default function Terms() {
  return (
    <LegalLayout
      testId="terms-page"
      eyebrow="Legal"
      title="Terms & Conditions"
      subtitle="Please read these terms carefully before using our website and purchasing our products."
      updated="June 2026"
      sections={[
        {
          heading: "Acceptance of terms",
          body: [
            `By accessing and using the ${SITE.legal} website, you agree to be bound by these Terms & Conditions and all applicable laws and regulations. If you do not agree, please do not use this site.`,
          ],
        },
        {
          heading: "Products & information",
          body: [
            "We strive to display our products and their descriptions as accurately as possible. Colors, packaging and details may vary slightly. Product information is provided for general purposes and is not medical advice.",
          ],
        },
        {
          heading: "Health disclaimer",
          body: [
            "Our products are food and wellness items and are not intended to diagnose, treat, cure or prevent any disease. Statements have not been evaluated by the FDA. Always consult a qualified healthcare professional before beginning any new wellness routine.",
          ],
        },
        {
          heading: "Intellectual property",
          body: [
            "All content on this website, including text, graphics, logos, and images, is the property of Medina Lia Company LLC and is protected by applicable intellectual property laws. You may not reproduce or redistribute it without permission.",
          ],
        },
        {
          heading: "Limitation of liability",
          body: [
            "To the fullest extent permitted by law, Medina Lia Company LLC shall not be liable for any indirect, incidental or consequential damages arising from the use of our website or products.",
          ],
        },
        {
          heading: "Changes to these terms",
          body: [
            "We reserve the right to update these Terms & Conditions at any time. Continued use of the website after changes constitutes acceptance of the revised terms.",
          ],
        },
        {
          heading: "Contact",
          body: [`Questions about these terms? Reach us at ${SITE.email} or ${SITE.phone}.`],
        },
      ]}
    />
  );
}
